module.exports = __webpack_public_path__ + "assets/images/pages/kfc/kfc-3.png?cc5ca0c3";